import { CURRENT_USER_FETCH } from '../constants/currentUserTypes';

export function currentUserFetch() {
  return { type: CURRENT_USER_FETCH };
}



// WEBPACK FOOTER //
// ./app/actions/currentUserActions.js